export const POSITIVE_CORRELATION_COLOR = { red: 89, green: 126, blue: 170 };
export const NEGATIVE_CORRELATION_COLOR = { red: 230, green: 100, blue: 101 };
export const NEUTRAL_CORRELATION_COLOR = { red: 255, green: 255, blue: 255 };
